import { useGetGoogleClientIdQuery } from "../../generated";

export default function useGoogleClientId() {
  const { data } = useGetGoogleClientIdQuery();

  return data?.configuration.googleClientId;
}
